import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import RightSlider from './RightSlider.js';
import { selectorButtonCss, selectorButtonSmallCss, } from './utils/selectorButtonStyles.js';
const getActiveButtons = (hasSkippedActions) => [hasSkippedActions && 'Sweep', 'Commit'].filter((a) => !!a);
const ActionListHeader = ({ onSearch, hasSkippedActions, hasStagedActions, onCommit, onSweep, hideMainButtons, searchValue, }) => (_jsxs("div", { css: (theme) => ({
        display: 'flex',
        flex: '0 0 auto',
        alignItems: 'center',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        borderColor: theme.LIST_BORDER_COLOR,
    }), children: [_jsx("input", { css: (theme) => ({
                outline: 'none',
                border: 'none',
                width: '100%',
                padding: '5px 10px',
                fontSize: '1em',
                fontFamily: 'monaco, Consolas, "Lucida Console", monospace',
                backgroundColor: theme.BACKGROUND_COLOR,
                color: theme.TEXT_COLOR,
                '&::-webkit-input-placeholder': {
                    color: theme.TEXT_PLACEHOLDER_COLOR,
                },
                '&::-moz-placeholder': {
                    color: theme.TEXT_PLACEHOLDER_COLOR,
                },
            }), onChange: (e) => onSearch(e.target.value), placeholder: "filter...", value: searchValue }), !hideMainButtons && (_jsx("div", { css: { position: 'relative', height: '20px' }, children: _jsx(RightSlider, { shown: hasStagedActions, children: _jsx("div", { css: { display: 'inline-flex', marginRight: '10px' }, children: getActiveButtons(hasSkippedActions).map((btn) => (_jsx("div", { onClick: () => ({
                            Commit: onCommit,
                            Sweep: onSweep,
                        })[btn](), css: [selectorButtonCss, selectorButtonSmallCss], children: btn }, btn))) }) }) }))] }));
export default ActionListHeader;
